import { render } from "./DetailSlip.vue?vue&type=template&id=3c131a13&scoped=true"
import script from "./DetailSlip.vue?vue&type=script&lang=js"
export * from "./DetailSlip.vue?vue&type=script&lang=js"

import "./DetailSlip.vue?vue&type=style&index=0&id=3c131a13&scoped=true&lang=css"
import "./DetailSlip.vue?vue&type=style&index=1&id=3c131a13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c131a13"]])

export default __exports__